import { useState } from "react";
import { Dialog } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import {
  SettingsDialogContent,
  SettingsDialogFooter,
  SettingsDialogHeader,
} from "@/components/ui/settings-dialog";
import { toast } from "sonner";

interface DeleteMessageDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function DeleteMessageDialog({
  open,
  onOpenChange,
  onConfirm,
}: DeleteMessageDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <SettingsDialogContent size="sm">
        <SettingsDialogHeader
          title="Delete message"
          description="Are you sure you want to delete this message? This can't be undone."
        />

        <SettingsDialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            disabled={isDeleting}
            onClick={() => {
              setIsDeleting(true);
              try {
                onConfirm();
                onOpenChange(false);
              } catch (err) {
                console.error("[delete-message] delete failed:", err);
                toast.error("Failed to delete message. Please try again.");
              } finally {
                setIsDeleting(false);
              }
            }}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </SettingsDialogFooter>
      </SettingsDialogContent>
    </Dialog>
  );
}
